import './footer.css';

import footerLogo from '../../assets/Bloomberg.Center.for.Government.Excellence.logo.horizontal.white.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faArrowAltCircleUp, faArrowCircleUp, faX } from '@fortawesome/free-solid-svg-icons';

const Footer = ( {showFeedbackLink }) => {
    return (
        <footer>
            <div className='footer-top'>
                <img src={footerLogo} alt="GovEx Logo" className="footer-logo-image" />
                <ul className='footer-list'>
                    <li><a href="https://govex.jhu.edu/what-we-do/" target="_blank" rel="noreferrer">What We Do</a></li>
                    <li><a href="https://govex.jhu.edu/about/" target="_blank" rel="noreferrer">About Us</a></li>
                    <li><a href="https://govex.jhu.edu/news/" target="_blank" rel="noreferrer">News & Media</a></li>
                    <li><a href="https://govex.jhu.edu/careers/" target="_blank" rel="noreferrer">Careers</a></li>
                    <li><a href="https://govex.jhu.edu/contact/" target="_blank" rel="noreferrer">Contact</a></li>
                   { showFeedbackLink &&  <li className='footer-feedback-link no-print'><a href='https://form.asana.com/?k=4XWA1HSIKdmMfB9GZZVNmA&d=1108016200678557' target='_blank' rel="noreferrer">Submit Feedback</a></li>}
                </ul>
            </div>
            <div className='footer-bottom'>
                <p className='desktop-disclaimer'><a href='https://it.johnshopkins.edu/policies-privacystatement/'>Privacy Policy</a> | Copyright 2025</p>
                <ul className='footer-bottom-list'>
                    <li><a href='https://www.linkedin.com/company/govex/'><FontAwesomeIcon icon={faLinkedinIn}></FontAwesomeIcon></a></li>
                    <li><a href='https://www.instagram.com/govex_jhu/'><FontAwesomeIcon icon={faInstagram}></FontAwesomeIcon></a></li>
                    <li><a href='http://twitter.com/govex_jhu'><FontAwesomeIcon icon={faXTwitter}></FontAwesomeIcon></a></li>
                    <li><a href='https://www.facebook.com/govexjhu/'><FontAwesomeIcon icon={faFacebookF}></FontAwesomeIcon></a></li>
                    <li className='up-arrow no-print' onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}><FontAwesomeIcon icon={faArrowAltCircleUp}></FontAwesomeIcon></li>
                </ul>   
            </div>
            <div className='mobile-footer-bottom'>
                <p className='mobile-disclaimer'><a href='https://it.johnshopkins.edu/policies-privacystatement/'>Privacy Policy</a> | Copyright 2025</p>
            </div>
        </footer>
    );
};

export default Footer;